(function(){
  if (window.__ES_TOP_FUNNEL_TRACKING__) return;
  window.__ES_TOP_FUNNEL_TRACKING__ = true;

  var ENDPOINT = "https://3ee4538993aa2d.lhr.life/collect";
  var PRODUCTS = {
    'box-digesthe': '49280332792145',
    'box-purethe': '49280332464465'
  };
  var SALES_PAGES = {
    '/pages/decouvrir-le-rituel-digesthe': 'box-digesthe',
    '/pages/decouvrir-le-rituel-purethe': 'box-purethe'
  };
  function currentProductHandle(){
    var m = location.pathname.match(/^\/products\/([^/?#]+)/);
    if (m && PRODUCTS[m[1]]) return m[1];
    return SALES_PAGES[location.pathname] || '';
  }
  function currentVariantId(){ return PRODUCTS[currentProductHandle()] || ''; }

  function uuid(){
    try { return crypto.randomUUID(); } catch(e) { return 's-' + Date.now() + '-' + Math.random().toString(16).slice(2); }
  }
  function getSessionId(){
    try {
      var k = 'es_tf_sid';
      var v = sessionStorage.getItem(k);
      if (!v) { v = uuid(); sessionStorage.setItem(k, v); }
      return v;
    } catch(e) { return ''; }
  }
  function getVisitorId(){
    // Pas de cookie. ID local anonyme uniquement pour compter des sessions/retours, soumis au consentement analytics.
    try {
      var k = 'es_tf_vid';
      var v = localStorage.getItem(k);
      if (!v) { v = uuid(); localStorage.setItem(k, v); }
      return v;
    } catch(e) { return ''; }
  }
  function consentAllowed(){
    if (location.search.indexOf('es_track_test=1') !== -1) return true;
    try {
      if (window.Shopify && Shopify.customerPrivacy && typeof Shopify.customerPrivacy.analyticsProcessingAllowed === 'function') {
        return Shopify.customerPrivacy.analyticsProcessingAllowed();
      }
    } catch(e) {}
    // Si l'API consentement n'est pas disponible, on reste prudent: pas de tracking.
    return false;
  }
  function qs(name){
    try { return new URL(location.href).searchParams.get(name) || ''; } catch(e) { return ''; }
  }
  function uaFamily(){
    var ua = navigator.userAgent || '';
    if (/Instagram/i.test(ua)) return 'instagram';
    if (/TikTok/i.test(ua)) return 'tiktok';
    if (/Pinterest/i.test(ua)) return 'pinterest';
    if (/Mobile/i.test(ua)) return 'mobile_browser';
    return 'desktop_browser';
  }
  function basePayload(type){
    return {
      event_type: type,
      path: location.pathname,
      url: location.href,
      referrer: document.referrer || '',
      utm_source: qs('utm_source'),
      utm_medium: qs('utm_medium'),
      utm_campaign: qs('utm_campaign'),
      utm_content: qs('utm_content'),
      pin_variant: qs('variant') || qs('pin_variant'),
      product_handle: currentProductHandle(),
      variant_id: currentVariantId(),
      session_id: getSessionId(),
      visitor_id: getVisitorId(),
      user_agent_family: uaFamily(),
      experiment_id: (window.__ES_CLICK_TEST && window.__ES_CLICK_TEST.id) || '',
      experiment_variant: (window.__ES_CLICK_TEST && window.__ES_CLICK_TEST.variant) || ''
    };
  }
  function send(type, extra){
    if (!consentAllowed()) return;
    var payload = basePayload(type);
    if (extra) for (var k in extra) payload[k] = String(extra[k] || '').slice(0,500);
    try {
      var body = JSON.stringify(payload);
      fetch(ENDPOINT, {method:'POST', mode:'cors', keepalive:true, headers:{'Content-Type':'application/json'}, body:body}).catch(function(){
        try {
          if (navigator.sendBeacon) {
            navigator.sendBeacon(ENDPOINT, new Blob([body], {type: 'application/json'}));
          }
        } catch(e2) {}
      });
    } catch(e) {}
  }
  function classifyLink(el){
    var href = el && el.href || '';
    var text = (el && el.innerText || el && el.getAttribute && el.getAttribute('aria-label') || '').trim();
    if (href.indexOf('/cart/') !== -1 || href.indexOf('/cart/add') !== -1) return 'add_to_cart_click';
    if (href.indexOf('/checkout') !== -1) return 'checkout_click';
    for (var handle in PRODUCTS) {
      if (href.indexOf('/products/' + handle) !== -1) return 'cta_click';
    }
    if (/digesth|pureth|rituel|cure|commencer|découvrir/i.test(text)) return 'cta_click';
    return '';
  }
  function applyPuretheSafeOptimization(){
    var isPure = location.pathname.indexOf('/products/box-purethe') === 0 || location.pathname.indexOf('/pages/decouvrir-le-rituel-purethe') === 0;
    if (!isPure) return;
    var cart = '/cart/49280332464465:1';
    var replacements = [
      [/35€ la cure complète/g, '38,20€ la box complète'],
      [/1,67€ \/ jour/g, '1,82€ / jour'],
      [/4 prises quotidiennes/g, '4 assemblages bio guidés'],
      [/4 prises par jour/g, '4 assemblages bio guidés'],
      [/4 prises\/jour/g, '4 assemblages bio guidés'],
      [/Commencer ma cure détox 21 jours/g, 'Je commence mon rituel détox douce 21 jours'],
      [/Commencer ma cure 21 jours/g, 'Je commence mon rituel 21 jours'],
      [/Je commence ma cure 21 jours/g, 'Je commence mon rituel 21 jours'],
      [/Installer mon rituel détox/g, 'Installer mon rituel détox douce']
    ];
    function walk(node){
      if (!node) return;
      if (node.nodeType === Node.TEXT_NODE) {
        var v = node.nodeValue;
        replacements.forEach(function(r){ v = v.replace(r[0], r[1]); });
        node.nodeValue = v;
        return;
      }
      if (node.nodeType === Node.ELEMENT_NODE && !/SCRIPT|STYLE|NOSCRIPT/.test(node.tagName)) {
        Array.prototype.slice.call(node.childNodes).forEach(walk);
      }
    }
    walk(document.body);
    Array.prototype.slice.call(document.querySelectorAll('a')).forEach(function(a){
      var t = (a.innerText || '').toLowerCase();
      var href = a.getAttribute('href') || '';
      if (href === '#' || href === '#acheter' || /commence|rituel|pureth|détox|cure/.test(t)) {
        if (href.indexOf('/products/box-purethe') !== -1 && /composition|découvrir/.test(t)) return;
        a.setAttribute('href', cart);
      }
    });
    if (!document.querySelector('[data-es-purethe-reassurance]')) {
      var firstCta = document.querySelector('a[href="'+cart+'"], button[name="add"]');
      if (firstCta && firstCta.parentNode) {
        var p = document.createElement('p');
        p.setAttribute('data-es-purethe-reassurance','1');
        p.style.cssText='margin-top:10px;font-size:14px;color:#6B6B6B;';
        p.textContent='Paiement sécurisé • Livraison 48h • Guide inclus';
        firstCta.parentNode.insertBefore(p, firstCta.nextSibling);
      }
    }
  }
  function init(){
    var path = location.pathname;
    applyPuretheSafeOptimization();
    send('page_view');
    if (path.indexOf('/products/box-digesthe') !== -1 || path.indexOf('/products/box-purethe') !== -1) send('product_view');
    if (SALES_PAGES[path]) send('sales_page_view');
    if (path.indexOf('/cart') === 0) send('cart_view');

    document.addEventListener('click', function(ev){
      var el = ev.target && ev.target.closest && ev.target.closest('a,button');
      if (!el) return;
      var type = '';
      var label = (el.innerText || el.getAttribute('aria-label') || el.name || '').trim();
      if (el.matches('button[name="add"], form[action*="/cart/add"] button, .product-form__submit')) type = 'add_to_cart_click';
      if (!type && el.tagName === 'A') type = classifyLink(el);
      if (type) send(type, {target: (el.href || label || '').slice(0,500)});
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
